import { cn } from '@lair-finance/util'
import { AppMenu } from '@/domains/header/ui/AppMenu'
import { MenuList } from '@/domains/header/ui/MenuList'
import { useResponsive } from '@/features/responsive/hooks/useResponsive.ts'
import { HeaderContent } from '@/domains/header/ui/HeaderContent.tsx'
import { HeaderActions } from '@/domains/header/ui/HeaderActions.tsx'
import { NotificationBar } from '@/domains/header/ui/NotificationBar.tsx'

export function Header({ className }: { className?: string }) {
  const isDesktop = useResponsive('desktop')

  return (
    <div className={cn('flex flex-col', className)}>
      <NotificationBar />
      <HeaderContent
        app={
          isDesktop && (
            <div className={'inline-flex items-center gap-x-6'}>
              <AppMenu />
              <MenuList />
            </div>
          )
        }
        actions={<HeaderActions />}
      />
    </div>
  )
}
